/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { ConversionReportDto } from '../models';
// @ts-ignore
import type { ImportRefusalDto } from '../models';
// @ts-ignore
import type { ImportReportDto } from '../models';
// @ts-ignore
import type { ImportTooLargeDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { QuestionPurposeDto } from '../models';
// @ts-ignore
import type { QuestionTypeDto } from '../models';
// @ts-ignore
import type { SourceTypeDto } from '../models';
// @ts-ignore
import type { TranslationStatusDto } from '../models';
// @ts-ignore
import type { VersionStatusDto } from '../models';
/**
 * QuestionImportApi - axios parameter creator
 * @export
 */
export const QuestionImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Questions the client keeps in a spreadsheet of their own — a question pool — come into the bank through a conversion to the template, and then the import. The old layout: a question is a row with its number in NR and its text in Pytanie, its answers are the rows under it with a letter in NR, and the right answer is the one shown on a green background, letter or text. Positions are columns marked with x, the source is a word from a list, and Uwagi holds notes. This check reads the file as the conversion would and lists what the template will lack, question by question; nothing is saved and no file comes back. Only for the time the old files are being moved.
         * @summary Read a question pool in its old layout and say what a conversion leaves to fix
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
         * @param {string} categoryId The category in use every question goes into; the old layout has none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQuestionPoolConversion: async (file: File, categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('checkQuestionPoolConversion', 'file', file)
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('checkQuestionPoolConversion', 'categoryId', categoryId)
            const localVarPath = `/api/v1/questions/import/conversion/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.append('categoryId', categoryId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The questions of the file laid out as the template, ready to be checked and imported once someone has filled in what the conversion could not read: the sheet \"Pytania\" — the template\'s columns, then nr and uwagi with the question\'s number and notes from the old file, which the import passes over — an empty sheet \"Źródła\", and the sheet \"Do poprawienia\" with what checkQuestionPoolConversion reports, in Polish. A cell the conversion could not read stays empty rather than guessed, so the import\'s check points at it. Every question is a test question for 1 point in Polish, a single or multiple choice by its number of right answers, saved as a draft. Nothing is saved.
         * @summary Convert a question pool in its old layout into the template
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
         * @param {string} categoryId The category in use every question goes into; the old layout has none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertQuestionPool: async (file: File, categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('convertQuestionPool', 'file', file)
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('convertQuestionPool', 'categoryId', categoryId)
            const localVarPath = `/api/v1/questions/import/conversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.append('categoryId', categoryId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The same filters as listQuestions, on every page, in the layout of the template — so the file imports again, into another environment. Each question comes with the version the list shows, in its source language, and with every source: the first in its row, the rest and every link in \"Źródła\". Sorted by key.
         * @summary Export the questions the list shows
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {QuestionPurposeDto} [purpose] 
         * @param {VersionStatusDto} [status] 
         * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
         * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
         * @param {string} [positionCode] 
         * @param {string} [locale] Language the text search uses. Defaults to pl.
         * @param {TranslationStatusDto} [translationStatus] 
         * @param {string} [author] 
         * @param {string} [q] 
         * @param {string} [changedFrom] 
         * @param {string} [changedTo] 
         * @param {boolean} [forReview] 
         * @param {string} [procedureName] Narrows to questions citing this procedure, as in listQuestions. After forReview, so the parameters before it keep their places in generated clients.
         * @param {boolean} [allPositions] As in listQuestions. Last, for the same reason as procedureName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportQuestions: async (categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (purpose !== undefined) {
                localVarQueryParameter['purpose'] = purpose;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (tagId) {
                localVarQueryParameter['tagId'] = tagId.join(COLLECTION_FORMATS.csv);
            }

            if (positionCode !== undefined) {
                localVarQueryParameter['positionCode'] = positionCode;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (translationStatus !== undefined) {
                localVarQueryParameter['translationStatus'] = translationStatus;
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (changedFrom !== undefined) {
                localVarQueryParameter['changedFrom'] = (changedFrom as any instanceof Date) ?
                    (changedFrom as any).toISOString().substring(0,10) :
                    changedFrom;
            }

            if (changedTo !== undefined) {
                localVarQueryParameter['changedTo'] = (changedTo as any instanceof Date) ?
                    (changedTo as any).toISOString().substring(0,10) :
                    changedTo;
            }

            if (forReview !== undefined) {
                localVarQueryParameter['forReview'] = forReview;
            }

            if (procedureName !== undefined) {
                localVarQueryParameter['procedureName'] = procedureName;
            }

            if (allPositions !== undefined) {
                localVarQueryParameter['allPositions'] = allPositions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The file to start from: the sheet \"Pytania\" with every column and a few example rows (delete them or keep them), the sheet \"Źródła\" with an example of a question\'s further sources and links, the dictionaries behind the drop-down lists, and a sheet of instructions in Polish. It always matches what the import reads. The sheet \"Stanowiska\" lists the positions of the dictionary as it is at the moment of download: the column stanowiska takes their numbers, or their names where a name is not shared, or the word wszystkie.
         * @summary The empty template, with instructions and examples
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionImportTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions/import/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves every row as a question with its first version, a draft, in one transaction — or in force with its wording approved, where the row says TAK in \"aktywne\". With any row refused nothing is saved, and the answer is 400 carrying the same report a check gives. Keys left empty are issued from the category\'s prefix and a counter, as for the form; tags the file names and the dictionary lacks are created. Every question saved gets its \"created\" entry in its history, and one saved in force the entry an activation by hand leaves.
         * @summary Import a spreadsheet of questions
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importQuestions: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importQuestions', 'file', file)
            const localVarPath = `/api/v1/questions/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the file as the import would and reports every problem, row by row, each with the column at fault and a code the interface can put into its own words. Nothing is saved; the confirmation screen is built from this. A file that cannot be read as the template at all — not a spreadsheet, no sheet \"Pytania\", a required column missing in it or in \"Źródła\" — is refused with 400 before any row is looked at. \"Źródła\" may be left out.
         * @summary Check a spreadsheet of questions without saving anything
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateQuestionImport: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('validateQuestionImport', 'file', file)
            const localVarPath = `/api/v1/questions/import/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionImportApi - functional programming interface
 * @export
 */
export const QuestionImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionImportApiAxiosParamCreator(configuration)
    return {
        /**
         * Questions the client keeps in a spreadsheet of their own — a question pool — come into the bank through a conversion to the template, and then the import. The old layout: a question is a row with its number in NR and its text in Pytanie, its answers are the rows under it with a letter in NR, and the right answer is the one shown on a green background, letter or text. Positions are columns marked with x, the source is a word from a list, and Uwagi holds notes. This check reads the file as the conversion would and lists what the template will lack, question by question; nothing is saved and no file comes back. Only for the time the old files are being moved.
         * @summary Read a question pool in its old layout and say what a conversion leaves to fix
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
         * @param {string} categoryId The category in use every question goes into; the old layout has none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkQuestionPoolConversion(file: File, categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversionReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkQuestionPoolConversion(file, categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionImportApi.checkQuestionPoolConversion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The questions of the file laid out as the template, ready to be checked and imported once someone has filled in what the conversion could not read: the sheet \"Pytania\" — the template\'s columns, then nr and uwagi with the question\'s number and notes from the old file, which the import passes over — an empty sheet \"Źródła\", and the sheet \"Do poprawienia\" with what checkQuestionPoolConversion reports, in Polish. A cell the conversion could not read stays empty rather than guessed, so the import\'s check points at it. Every question is a test question for 1 point in Polish, a single or multiple choice by its number of right answers, saved as a draft. Nothing is saved.
         * @summary Convert a question pool in its old layout into the template
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
         * @param {string} categoryId The category in use every question goes into; the old layout has none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertQuestionPool(file: File, categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertQuestionPool(file, categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionImportApi.convertQuestionPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The same filters as listQuestions, on every page, in the layout of the template — so the file imports again, into another environment. Each question comes with the version the list shows, in its source language, and with every source: the first in its row, the rest and every link in \"Źródła\". Sorted by key.
         * @summary Export the questions the list shows
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {QuestionPurposeDto} [purpose] 
         * @param {VersionStatusDto} [status] 
         * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
         * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
         * @param {string} [positionCode] 
         * @param {string} [locale] Language the text search uses. Defaults to pl.
         * @param {TranslationStatusDto} [translationStatus] 
         * @param {string} [author] 
         * @param {string} [q] 
         * @param {string} [changedFrom] 
         * @param {string} [changedTo] 
         * @param {boolean} [forReview] 
         * @param {string} [procedureName] Narrows to questions citing this procedure, as in listQuestions. After forReview, so the parameters before it keep their places in generated clients.
         * @param {boolean} [allPositions] As in listQuestions. Last, for the same reason as procedureName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportQuestions(categoryId, type, purpose, status, source, tagId, positionCode, locale, translationStatus, author, q, changedFrom, changedTo, forReview, procedureName, allPositions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionImportApi.exportQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The file to start from: the sheet \"Pytania\" with every column and a few example rows (delete them or keep them), the sheet \"Źródła\" with an example of a question\'s further sources and links, the dictionaries behind the drop-down lists, and a sheet of instructions in Polish. It always matches what the import reads. The sheet \"Stanowiska\" lists the positions of the dictionary as it is at the moment of download: the column stanowiska takes their numbers, or their names where a name is not shared, or the word wszystkie.
         * @summary The empty template, with instructions and examples
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionImportTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionImportTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionImportApi.getQuestionImportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves every row as a question with its first version, a draft, in one transaction — or in force with its wording approved, where the row says TAK in \"aktywne\". With any row refused nothing is saved, and the answer is 400 carrying the same report a check gives. Keys left empty are issued from the category\'s prefix and a counter, as for the form; tags the file names and the dictionary lacks are created. Every question saved gets its \"created\" entry in its history, and one saved in force the entry an activation by hand leaves.
         * @summary Import a spreadsheet of questions
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importQuestions(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importQuestions(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionImportApi.importQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the file as the import would and reports every problem, row by row, each with the column at fault and a code the interface can put into its own words. Nothing is saved; the confirmation screen is built from this. A file that cannot be read as the template at all — not a spreadsheet, no sheet \"Pytania\", a required column missing in it or in \"Źródła\" — is refused with 400 before any row is looked at. \"Źródła\" may be left out.
         * @summary Check a spreadsheet of questions without saving anything
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateQuestionImport(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateQuestionImport(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionImportApi.validateQuestionImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionImportApi - factory interface
 * @export
 */
export const QuestionImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionImportApiFp(configuration)
    return {
        /**
         * Questions the client keeps in a spreadsheet of their own — a question pool — come into the bank through a conversion to the template, and then the import. The old layout: a question is a row with its number in NR and its text in Pytanie, its answers are the rows under it with a letter in NR, and the right answer is the one shown on a green background, letter or text. Positions are columns marked with x, the source is a word from a list, and Uwagi holds notes. This check reads the file as the conversion would and lists what the template will lack, question by question; nothing is saved and no file comes back. Only for the time the old files are being moved.
         * @summary Read a question pool in its old layout and say what a conversion leaves to fix
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
         * @param {string} categoryId The category in use every question goes into; the old layout has none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQuestionPoolConversion(file: File, categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversionReportDto> {
            return localVarFp.checkQuestionPoolConversion(file, categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * The questions of the file laid out as the template, ready to be checked and imported once someone has filled in what the conversion could not read: the sheet \"Pytania\" — the template\'s columns, then nr and uwagi with the question\'s number and notes from the old file, which the import passes over — an empty sheet \"Źródła\", and the sheet \"Do poprawienia\" with what checkQuestionPoolConversion reports, in Polish. A cell the conversion could not read stays empty rather than guessed, so the import\'s check points at it. Every question is a test question for 1 point in Polish, a single or multiple choice by its number of right answers, saved as a draft. Nothing is saved.
         * @summary Convert a question pool in its old layout into the template
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
         * @param {string} categoryId The category in use every question goes into; the old layout has none.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertQuestionPool(file: File, categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.convertQuestionPool(file, categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * The same filters as listQuestions, on every page, in the layout of the template — so the file imports again, into another environment. Each question comes with the version the list shows, in its source language, and with every source: the first in its row, the rest and every link in \"Źródła\". Sorted by key.
         * @summary Export the questions the list shows
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {QuestionPurposeDto} [purpose] 
         * @param {VersionStatusDto} [status] 
         * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
         * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
         * @param {string} [positionCode] 
         * @param {string} [locale] Language the text search uses. Defaults to pl.
         * @param {TranslationStatusDto} [translationStatus] 
         * @param {string} [author] 
         * @param {string} [q] 
         * @param {string} [changedFrom] 
         * @param {string} [changedTo] 
         * @param {boolean} [forReview] 
         * @param {string} [procedureName] Narrows to questions citing this procedure, as in listQuestions. After forReview, so the parameters before it keep their places in generated clients.
         * @param {boolean} [allPositions] As in listQuestions. Last, for the same reason as procedureName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportQuestions(categoryId, type, purpose, status, source, tagId, positionCode, locale, translationStatus, author, q, changedFrom, changedTo, forReview, procedureName, allPositions, options).then((request) => request(axios, basePath));
        },
        /**
         * The file to start from: the sheet \"Pytania\" with every column and a few example rows (delete them or keep them), the sheet \"Źródła\" with an example of a question\'s further sources and links, the dictionaries behind the drop-down lists, and a sheet of instructions in Polish. It always matches what the import reads. The sheet \"Stanowiska\" lists the positions of the dictionary as it is at the moment of download: the column stanowiska takes their numbers, or their names where a name is not shared, or the word wszystkie.
         * @summary The empty template, with instructions and examples
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionImportTemplate(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getQuestionImportTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * Saves every row as a question with its first version, a draft, in one transaction — or in force with its wording approved, where the row says TAK in \"aktywne\". With any row refused nothing is saved, and the answer is 400 carrying the same report a check gives. Keys left empty are issued from the category\'s prefix and a counter, as for the form; tags the file names and the dictionary lacks are created. Every question saved gets its \"created\" entry in its history, and one saved in force the entry an activation by hand leaves.
         * @summary Import a spreadsheet of questions
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importQuestions(file: File, options?: RawAxiosRequestConfig): AxiosPromise<ImportReportDto> {
            return localVarFp.importQuestions(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the file as the import would and reports every problem, row by row, each with the column at fault and a code the interface can put into its own words. Nothing is saved; the confirmation screen is built from this. A file that cannot be read as the template at all — not a spreadsheet, no sheet \"Pytania\", a required column missing in it or in \"Źródła\" — is refused with 400 before any row is looked at. \"Źródła\" may be left out.
         * @summary Check a spreadsheet of questions without saving anything
         * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateQuestionImport(file: File, options?: RawAxiosRequestConfig): AxiosPromise<ImportReportDto> {
            return localVarFp.validateQuestionImport(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionImportApi - interface
 * @export
 * @interface QuestionImportApi
 */
export interface QuestionImportApiInterface {
    /**
     * Questions the client keeps in a spreadsheet of their own — a question pool — come into the bank through a conversion to the template, and then the import. The old layout: a question is a row with its number in NR and its text in Pytanie, its answers are the rows under it with a letter in NR, and the right answer is the one shown on a green background, letter or text. Positions are columns marked with x, the source is a word from a list, and Uwagi holds notes. This check reads the file as the conversion would and lists what the template will lack, question by question; nothing is saved and no file comes back. Only for the time the old files are being moved.
     * @summary Read a question pool in its old layout and say what a conversion leaves to fix
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
     * @param {string} categoryId The category in use every question goes into; the old layout has none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApiInterface
     */
    checkQuestionPoolConversion(file: File, categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversionReportDto>;

    /**
     * The questions of the file laid out as the template, ready to be checked and imported once someone has filled in what the conversion could not read: the sheet \"Pytania\" — the template\'s columns, then nr and uwagi with the question\'s number and notes from the old file, which the import passes over — an empty sheet \"Źródła\", and the sheet \"Do poprawienia\" with what checkQuestionPoolConversion reports, in Polish. A cell the conversion could not read stays empty rather than guessed, so the import\'s check points at it. Every question is a test question for 1 point in Polish, a single or multiple choice by its number of right answers, saved as a draft. Nothing is saved.
     * @summary Convert a question pool in its old layout into the template
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
     * @param {string} categoryId The category in use every question goes into; the old layout has none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApiInterface
     */
    convertQuestionPool(file: File, categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * The same filters as listQuestions, on every page, in the layout of the template — so the file imports again, into another environment. Each question comes with the version the list shows, in its source language, and with every source: the first in its row, the rest and every link in \"Źródła\". Sorted by key.
     * @summary Export the questions the list shows
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {QuestionPurposeDto} [purpose] 
     * @param {VersionStatusDto} [status] 
     * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
     * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
     * @param {string} [positionCode] 
     * @param {string} [locale] Language the text search uses. Defaults to pl.
     * @param {TranslationStatusDto} [translationStatus] 
     * @param {string} [author] 
     * @param {string} [q] 
     * @param {string} [changedFrom] 
     * @param {string} [changedTo] 
     * @param {boolean} [forReview] 
     * @param {string} [procedureName] Narrows to questions citing this procedure, as in listQuestions. After forReview, so the parameters before it keep their places in generated clients.
     * @param {boolean} [allPositions] As in listQuestions. Last, for the same reason as procedureName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApiInterface
     */
    exportQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * The file to start from: the sheet \"Pytania\" with every column and a few example rows (delete them or keep them), the sheet \"Źródła\" with an example of a question\'s further sources and links, the dictionaries behind the drop-down lists, and a sheet of instructions in Polish. It always matches what the import reads. The sheet \"Stanowiska\" lists the positions of the dictionary as it is at the moment of download: the column stanowiska takes their numbers, or their names where a name is not shared, or the word wszystkie.
     * @summary The empty template, with instructions and examples
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApiInterface
     */
    getQuestionImportTemplate(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Saves every row as a question with its first version, a draft, in one transaction — or in force with its wording approved, where the row says TAK in \"aktywne\". With any row refused nothing is saved, and the answer is 400 carrying the same report a check gives. Keys left empty are issued from the category\'s prefix and a counter, as for the form; tags the file names and the dictionary lacks are created. Every question saved gets its \"created\" entry in its history, and one saved in force the entry an activation by hand leaves.
     * @summary Import a spreadsheet of questions
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApiInterface
     */
    importQuestions(file: File, options?: RawAxiosRequestConfig): AxiosPromise<ImportReportDto>;

    /**
     * Reads the file as the import would and reports every problem, row by row, each with the column at fault and a code the interface can put into its own words. Nothing is saved; the confirmation screen is built from this. A file that cannot be read as the template at all — not a spreadsheet, no sheet \"Pytania\", a required column missing in it or in \"Źródła\" — is refused with 400 before any row is looked at. \"Źródła\" may be left out.
     * @summary Check a spreadsheet of questions without saving anything
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApiInterface
     */
    validateQuestionImport(file: File, options?: RawAxiosRequestConfig): AxiosPromise<ImportReportDto>;

}

/**
 * QuestionImportApi - object-oriented interface
 * @export
 * @class QuestionImportApi
 * @extends {BaseAPI}
 */
export class QuestionImportApi extends BaseAPI implements QuestionImportApiInterface {
    /**
     * Questions the client keeps in a spreadsheet of their own — a question pool — come into the bank through a conversion to the template, and then the import. The old layout: a question is a row with its number in NR and its text in Pytanie, its answers are the rows under it with a letter in NR, and the right answer is the one shown on a green background, letter or text. Positions are columns marked with x, the source is a word from a list, and Uwagi holds notes. This check reads the file as the conversion would and lists what the template will lack, question by question; nothing is saved and no file comes back. Only for the time the old files are being moved.
     * @summary Read a question pool in its old layout and say what a conversion leaves to fix
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
     * @param {string} categoryId The category in use every question goes into; the old layout has none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApi
     */
    public checkQuestionPoolConversion(file: File, categoryId: string, options?: RawAxiosRequestConfig) {
        return QuestionImportApiFp(this.configuration).checkQuestionPoolConversion(file, categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The questions of the file laid out as the template, ready to be checked and imported once someone has filled in what the conversion could not read: the sheet \"Pytania\" — the template\'s columns, then nr and uwagi with the question\'s number and notes from the old file, which the import passes over — an empty sheet \"Źródła\", and the sheet \"Do poprawienia\" with what checkQuestionPoolConversion reports, in Polish. A cell the conversion could not read stays empty rather than guessed, so the import\'s check points at it. Every question is a test question for 1 point in Polish, a single or multiple choice by its number of right answers, saved as a draft. Nothing is saved.
     * @summary Convert a question pool in its old layout into the template
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 questions. The first sheet with the columns NR and Pytanie is read.
     * @param {string} categoryId The category in use every question goes into; the old layout has none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApi
     */
    public convertQuestionPool(file: File, categoryId: string, options?: RawAxiosRequestConfig) {
        return QuestionImportApiFp(this.configuration).convertQuestionPool(file, categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The same filters as listQuestions, on every page, in the layout of the template — so the file imports again, into another environment. Each question comes with the version the list shows, in its source language, and with every source: the first in its row, the rest and every link in \"Źródła\". Sorted by key.
     * @summary Export the questions the list shows
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {QuestionPurposeDto} [purpose] 
     * @param {VersionStatusDto} [status] 
     * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
     * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
     * @param {string} [positionCode] 
     * @param {string} [locale] Language the text search uses. Defaults to pl.
     * @param {TranslationStatusDto} [translationStatus] 
     * @param {string} [author] 
     * @param {string} [q] 
     * @param {string} [changedFrom] 
     * @param {string} [changedTo] 
     * @param {boolean} [forReview] 
     * @param {string} [procedureName] Narrows to questions citing this procedure, as in listQuestions. After forReview, so the parameters before it keep their places in generated clients.
     * @param {boolean} [allPositions] As in listQuestions. Last, for the same reason as procedureName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApi
     */
    public exportQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig) {
        return QuestionImportApiFp(this.configuration).exportQuestions(categoryId, type, purpose, status, source, tagId, positionCode, locale, translationStatus, author, q, changedFrom, changedTo, forReview, procedureName, allPositions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The file to start from: the sheet \"Pytania\" with every column and a few example rows (delete them or keep them), the sheet \"Źródła\" with an example of a question\'s further sources and links, the dictionaries behind the drop-down lists, and a sheet of instructions in Polish. It always matches what the import reads. The sheet \"Stanowiska\" lists the positions of the dictionary as it is at the moment of download: the column stanowiska takes their numbers, or their names where a name is not shared, or the word wszystkie.
     * @summary The empty template, with instructions and examples
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApi
     */
    public getQuestionImportTemplate(options?: RawAxiosRequestConfig) {
        return QuestionImportApiFp(this.configuration).getQuestionImportTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves every row as a question with its first version, a draft, in one transaction — or in force with its wording approved, where the row says TAK in \"aktywne\". With any row refused nothing is saved, and the answer is 400 carrying the same report a check gives. Keys left empty are issued from the category\'s prefix and a counter, as for the form; tags the file names and the dictionary lacks are created. Every question saved gets its \"created\" entry in its history, and one saved in force the entry an activation by hand leaves.
     * @summary Import a spreadsheet of questions
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApi
     */
    public importQuestions(file: File, options?: RawAxiosRequestConfig) {
        return QuestionImportApiFp(this.configuration).importQuestions(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the file as the import would and reports every problem, row by row, each with the column at fault and a code the interface can put into its own words. Nothing is saved; the confirmation screen is built from this. A file that cannot be read as the template at all — not a spreadsheet, no sheet \"Pytania\", a required column missing in it or in \"Źródła\" — is refused with 400 before any row is looked at. \"Źródła\" may be left out.
     * @summary Check a spreadsheet of questions without saving anything
     * @param {File} file An .xlsx file of at most 5 MB and 2 000 question rows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImportApi
     */
    public validateQuestionImport(file: File, options?: RawAxiosRequestConfig) {
        return QuestionImportApiFp(this.configuration).validateQuestionImport(file, options).then((request) => request(this.axios, this.basePath));
    }
}

